module.exports = __webpack_public_path__ + "img/ico6.1ac435c3.svg";